<template>
  <div class="main-page">
    <div class="main-page__container">
      <div class="main-page__header header">
        <div class="header__content">
          <div class="header__block-first">
            <a href="#" class="header__logo">
              <img src="@/assets/img/logo.svg" alt="" />
            </a>
            <div class="header__slogan">
              <span>Заправим Ваш автомобиль</span>
              <span>в удобном для вас месте</span>
            </div>
          </div>
          <div>
            <button class="tariff__button"
                    @click="showModalTariff = true"
            >Цены</button>
          </div>
        </div>

        <div class="header__phone">
          телефон горячей линии
          <a class="header__phone-link" href="tel:88002222086">
            8 (800) 222-20-86
          </a>
        </div>
      </div>
      <div class="main-page__body">
        <div class="intro-text">
          <h2>МОБИЛЬНАЯ</h2>
          <span class="intro-wrapper">
                      <p class="intro-text__main-text">ДОСТАВКА<br />ТОПЛИВА
          </p>
            <img class="intro__main-img" src="@/assets/img/job-time.png" alt="workTime" />
          </span>


          <div class="intro-text__place">
            <button
              class="button-primary"
              @click="showModalRegistration = true"
            >
              Оформить заказ
            </button>
            <div class="intro-text__variants">
              <div class="intro-text__variants-links">
                <p>можно оформить через сайт</p>
                <p>или <a href="">скачать приложение</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-page__footer">
        <div class="main-page__footer-left">
          <div class="advantage">
            <div class="advantage__item advantage__item--npz">
              <img
                class="advantage__item-img"
                src="../assets/img/icon-npz.svg"
                alt=""
              />
              <p class="advantage__item-text">
                Мы <br>сотрудничаем с&nbsp;крупнейшими НПЗ
              </p>
            </div>
            <div class="advantage__item advantage__item--transport">
              <img
                class="advantage__item-img"
                src="../assets/img/icon-transport.svg"
                alt=""
              />
              <p class="advantage__item-text">
                Доставляем топливо со&nbsp;своей нефтебазы
              </p>
            </div>
            <div class="advantage__item advantage__item--canister">
              <img
                class="advantage__item-img"
                src="../assets/img/icon-canister.svg"
                alt=""
              />
              <p class="advantage__item-text">
                Поставка тары <br> 200/1000 литров
              </p>
            </div>
            <div class="advantage__item advantage__item--laboratory">
              <img
                class="advantage__item-img"
                src="../assets/img/icon-laboratory.svg"
                alt=""
              />
              <p class="advantage__item-text">
                Топливо проходит строжайший контроль качества и&nbsp;отвечает
                всем требованиям ГОСТа
              </p>
            </div>
          </div>
        </div>
        <div class="more-info">
          <div class="intro-text__variants">
            <div class="intro-text__variants-links">
              <p>можно оформить <a href="">через сайт</a></p>
              <p>или <a href="">скачать приложение</a></p>
            </div>
          </div>
          <div class="social-links">
            <a href="https://play.google.com/store/apps/details?id=com.ratio.client" target="_blank">
              <img src="@/assets/img/icon-google-link.svg" alt="google" />
            </a>
            <a href="https://apps.apple.com/ru/app/ultima-ratio-%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0-%D1%82%D0%BE%D0%BF%D0%BB%D0%B8%D0%B2%D0%B0/id6444177458" target="_blank">
              <img src="@/assets/img/icon-apple-link.svg" alt="apple" />
            </a>
            <a href="https://apps.rustore.ru/app/com.ratio.client" target="_blank">
              <img src="@/assets/img/icon-rustore-link.svg" alt="rustore" />
            </a>
            <div class="owner">
              <div class="owner__text">
                <span class="owner__line"></span>
                <span>от собственника</span>
                <span class="owner__line"></span>
              </div>
              <div class="owner__logos">
                <img
                  class="logo-ultima"
                  src="@/assets/img/logo-ultima.png"
                  alt=""
                />
                <img class="logo-sn" src="@/assets/img/logo-sn.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModalRegistration"
      :centered="false"
      :show-close="true"
    >
      <order-form :itemsSwitch="tariffs" />
    </modal>
    <modal
      :show.sync="showModalTariff"
      :centered="false"
      :show-close="true"
    >
      <modal-tariff :tariffs="tariffs" />
    </modal>
  </div>
</template>

<script>
import OrderForm from "@/components/OrderForm";
import ModalTariff from "@/components/ModalTariff";
import axios from "axios";

export default {
  name: "MainPage",
  components: {ModalTariff, OrderForm },
  data() {
    return {
      showModalRegistration: false,
      showModalTariff: false,
      tariffs: [],
    };
  },
  mounted() {
    this.loadFuelList()
  },
  methods: {
    async loadFuelList() {
      let url = new URL(`${process.env.VUE_APP_API_URL}/v1/tariff-scale/list-landing`);
      await axios
        .get(url)
        .then(response => {
          this.tariffs = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>
